import { migrationRepository, MigrationStatus } from '../repositories/MigrationRepository';

class MigrationService {
  /**
   * Check migration status for all domains
   */
  async checkMigrationStatus(): Promise<MigrationStatus[]> {
    return migrationRepository.checkMigrationStatus();
  }
}

export const migrationService = new MigrationService();
